import { Component, Input, OnInit } from "@angular/core";

@Component({
    selector: "love-it-display-boolean",
    templateUrl: "./display-boolean.component.html",
    styleUrls: ["./display-boolean.component.scss"],
    standalone: false
})
export class DisplayBooleanComponent implements OnInit {
  @Input() value: boolean;

  constructor() {}

  ngOnInit(): void {}
}
